import BouncingShrug from "./Shrug";

export const App = () => {
    return <BouncingShrug />;
};
